import React from 'react';
import {
  detailedInfoContainerCX,
  detailedInfoTextSkeletonCX,
  getHeroPhotoContainerCX,
  getListingCardContainerCX,
  priceSkeletonCX,
  skeletonWrapperCX,
} from './styles';

type ListingCardV3SkeletonProps = {
  displayName?: string;
};

const ListingCardV3Skeleton = ({ displayName = '' }: ListingCardV3SkeletonProps) => {
  return (
    <div className={skeletonWrapperCX} data-name="SkeletonWrapper">
      <article className={getListingCardContainerCX({})} data-name="ListingCardContainer">
        <figure className={getHeroPhotoContainerCX({ isLoading: true })} data-name="HeroPhotoContainerSkeleton" />
        <section className={detailedInfoContainerCX} data-name="DetailedInfoContainer">
          <div className={priceSkeletonCX} data-name="PriceSkeleton" />
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          {displayName ? (
            <h3>{displayName}</h3>
          ) : (
            <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          )}
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
        </section>
      </article>
    </div>
  );
};

export default ListingCardV3Skeleton;
